module.exports = "<p>\r\n  contractstatus works!\r\n</p>\r\n"